import React, {Component} from 'react';

class Footer extends Component {
    render() {
        return (
            <footer className="app-footer">
                <small>Created by Tõnis Kasekamp</small>
                <span className="float-right">Powered by <a href="http://coreui.io">CoreUI</a></span>
            </footer>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js